
function handleStory() {

  // quote media story
  var match = window.location.href.match(/investor-news\?qmodStoryID=([0-9]+)/);
  if (match) {
    //console.log(match[1]);

    var qtool = document.querySelector('.qtool');

    qtool.setAttribute('data-qmod-tool', 'fullnewsstory');
    qtool.setAttribute('data-qmod-params', '{"qmodStoryID":"'+match[1]+'"}');

    qtool.innerHTML = '<script type="text/template">'+
                '<div class="qmod-ui-tool qmod-fullnewsstory">'+
                  '<div class="qmod-news-datetime">'+
                    "{scope.fullnewsstory.data.qmnews.qmstory.datetime | momentjs true 'lll' tLang}"+
                  '</div>'+
                  '<div class="qmod-headlines"><h3 class="qmod-headline">{scope.fullnewsstory.data.qmnews.qmstory.qmheadline}</h3></div>'+
                  '<div class="qmod-story" rv-html="scope.fullnewsstory.data.qmnews.qmstory.qmtext"></div>'+
                '</div>'+
              '</script>';


    document.querySelector('.investor-news-articles__heading').style.display = 'none';
    document.querySelector('.investor-news-articles').className += " investor-news-articles__story";

    window.qMod.loadTools();
  }
}

export default function quoteMedia() {
  handleStory();

  //console.log('quote media');

  var qtools = document.querySelectorAll('.qtool');

  qtools.forEach(qtool => {
    var tool = qtool.dataset.qmodTool;
    //console.log(tool);

    if (tool == 'miniquotes' || tool =='filings' || tool == 'detailedquotetab' || tool == 'interactivechart' || tool == 'pricehistory') {
      qtool.setAttribute('data-qmod-params', '{"symbol":"SIEB"}');
    }
    else if (tool == 'fullnewssummary') {
      qtool.setAttribute('data-qmod-params', '{"storyURL":"/investor-relations/investor-news?qmodStoryID=", "symbol" : "SIEB", "excludeTopics" : "NONCOMPANY", "src" : "bwi", "resultsPerPage":4, "dateHeadings":false}');
    }
	});



}
